import { subtitleGroups } from '@/mocks/homeData';

export default function SubtitleGroups() {
  return (
    <section id="groups" className="w-full scroll-mt-28 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="font-label text-xs font-medium uppercase tracking-widest text-primary-600">
            Groups
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            字幕组来源：不同译法的风格差异
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            同一部作品往往有多个字幕组参与译制。它们关注的重点不同——有的追求对白完整，
            有的追求顺口易读。了解各自的风格，能帮你固定一个版本连续观看。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {subtitleGroups.map((group) => (
            <article
              key={group.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100/70 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-team-line text-xl" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {group.name}
              </h3>
              <p className="mt-1 font-label text-xs text-secondary-700">侧重：{group.focus}</p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{group.style}</p>
              <div className="mt-4 rounded-md bg-background-50 p-3 text-xs leading-relaxed text-foreground-600">
                {group.note}
              </div>
              <p className="mt-3 text-xs text-foreground-500">整理条目：{group.works} 条</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}